import {BLOG_TYPES_CONSTS} from "../constants";

export const initialState = {
    blogTypesList: [],
};

export default (state = initialState, action) => {
    switch (action.type) {
        case BLOG_TYPES_CONSTS.GET_BLOG_TYPES:
            return {
                ...state,
                blogTypesList: action.payload || [],
            };
        case BLOG_TYPES_CONSTS.CREATE_BLOG_TYPES:
            return {
                ...state,
                blogTypesList: [action.payload].concat(state.blogTypesList)
            };
        case BLOG_TYPES_CONSTS.UPDATE_BLOG_TYPES:
            return {
                ...state,
                blogTypesList: state.blogTypesList.map(item => item.id === action.payload.id
                    ? action.payload : item)
            };
        case BLOG_TYPES_CONSTS.DELETE_BLOG_TYPES_BY_ID:
            return {
                ...state,
                blogTypesList: state.blogTypesList.filter(item => item.id !== action.payload)
            };
        default:
            return state;
    }
}
